import { atom } from 'jotai';

export const selectedRewriteAtom = atom<RewriteItem | null>(null);

export const rewriteEditModalAtom = atom(false);

export const rewriteCreateModalAtom = atom(false);

export const rewriteUpdateMessageAtom = atom('');

export const rewriteUpdateHasErrorAtom = atom(false);

export const datasetsUpdateMessageAtom = atom('');

export const datasetsUpdateHasErrorAtom = atom(false);
